<template>
  <div class="col-12">
    <div class="graph-reports">
      <div class="col-md-4">
        <div class="board-imageManage lightblue">
          <a @click="scrollMeTo('income')">
            <!--   <img src="/images/Total Expenses.png" />      -->
            <vc-donut
              thickness="5"
              background="#fff"
              size="200"
              foreground="#007DFC"
            >
              <span style="color:#007DFC;" class="graph-circle-text">
                Total Income
              </span>
            </vc-donut>
          </a>
        </div>
        <div class="adminButtons" style="margin-top: 15px;">
          <div class="board-titleManage">
            <a @click="scrollMeTo('income')"
              ><span
                style="font-size: 20px; font-weight: bold; color: #007DFC;"
              >
                €{{ $filters.toCurrency(totalIncome) }}</span
              ></a
            >
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="board-imageManage lightblue" style="font-size: 110px;">
          <a @click="scrollMeTo('expenses')">
            <vc-donut
              thickness="5"
              background="#fff"
              start-angle=""
              size="200"
              foreground="#494848"
            >
              <span style="color: #494848;" class="graph-circle-text">
                Total Expenses
              </span>
            </vc-donut>
            <!--   <img src="/images/Total Expenses.png" />      -->
          </a>
        </div>
        <div class="adminButtons" style="margin-top: 15px;">
          <div class="board-titleManage">
            <a @click="scrollMeTo('expenses')"
              ><span
                style="font-size: 20px; font-weight: bold; color: #494848;"
              >
                €{{ $filters.toCurrency(totalExpenses) }}</span
              ></a
            >
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="board-imageManage lightblue" style="font-size: 110px;">
          <a @click="scrollMeTo('cash')">
            <!--   <img src="/images/Total Expenses.png" />      -->
            <vc-donut
              background="#fff"
              start-angle=""
              size="200"
              thickness="5"
              foreground="#727272"
            >
              <span style="color: #727272;" class="graph-circle-text">
                Cash Balance
              </span>
            </vc-donut>
          </a>
        </div>
        <div class="adminButtons" style="margin-top: 15px;">
          <div class="board-titleManage" style="color: #727272;">
            <a @click="scrollMeTo('cash')"
              ><span
                style="font-size: 20px; font-weight: bold; color: #727272;"
              >
                €{{ $filters.toCurrency(totalCash) }}</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "isOwner",
    "buildingId",
    "buildingName",
    "propertyId",
    "propertyName",
    "totalIncome",
    "totalExpenses",
    "totalCashDeposit",
    "totalCash",
    "sectionsTotalIncome",
    "sectionsTotalExpenses",
    "sectionsCashBalance",
  ],
  methods: {
    scrollMeTo(refName) {
      var element = this.$parent.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    numberInCircleSize: function (number) {
      if (number.toString().length <= 5) {
        return 35;
      } else if (
        (number.toString().length > 5) &
        (number.toString().length <= 7)
      ) {
        return 25;
      } else if (
        (number.toString().length > 7) &
        (number.toString().length <= 10)
      ) {
        return 18;
      } else {
        return 14;
      }
    },
  },
};
</script>
